import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import cn from 'classnames';

import * as styles from './StarsRow.css';

interface IStarsRow {
  title: string;
  required?: boolean;
}

export const StarsRow = ({ children, required, title }: React.PropsWithChildren<IStarsRow>) => {
  return (
    <div className={styles['row']}>
      <div className={cn(styles['title'], { [styles['required']]: required })}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      {children}
    </div>
  );
};
